import { useState } from "react"

import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { SignupFormContent } from "@/components/account/SignupFormContent"
import { SignupNotEnabledContent } from "@/components/account/SignupNotEnabledContent"
import { VerifyEmailCodeForm } from "@/components/account/VerifyEmailCodeForm"

export const Route = createFileRoute("/(public)/_account/signup")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ context: { store }, search }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: search.redirect || "/home" })
    }
  },
  component: RouteComponent,
  wrapInSuspense: false,
})

function RouteComponent() {
  const [verifyEmail, setVerifyEmail] = useState<string | null>(null)
  const { data: config } = usePublicBoundlessConfigRetrieveSuspense()
  if (!config.signupEnabled) {
    return <SignupNotEnabledContent />
  }

  return verifyEmail ? (
    <VerifyEmailCodeForm email={verifyEmail} />
  ) : (
    <SignupFormContent onSuccess={setVerifyEmail} />
  )
}
